import React from 'react'
import BlockContent from '@sanity/block-content-to-react'
import cx from 'classnames'
import vsbl from 'vsbl'

import PageLink from '@/link.js'
import store from '../../state/store.js'
import Image from '@/image.js'

const switchBackground = (value) => {
  store.hydrate({
    background: value
  })()
}

class BlockCta extends React.Component {
  constructor() {
    super()

    this.vs = null
    this.block = React.createRef()
  }
  handleCTA (copy, action) {
    if (action === 'jobs') {
      return <a className='button button__peach block button__outline' rel='noopener noreferrer' target='_blank' href='https://angel.co/company/re-store-2/jobs'><span>{copy}</span></a>
    } else {
      return (
        <PageLink to={action === 'application' ? '/apply' : ''} className='button button__peach block button__outline'>
          <span>{copy}</span>
        </PageLink>
      )
    }
  }
  componentDidMount () {
    this.vs = vsbl(this.block.current)(() => {
      switchBackground('one')
    }, () => {
      switchBackground('three')
    })

    this.vs.update()
  }
  componentWillUnmount () {
    this.vs.destroy()
  }
  render () {
    const {
      layout,
      ctaCopy,
      ctaAction,
      imageId,
      title,
      description
    } = this.props.content
    return (
      <div ref={this.block} className={cx('mxa pmy block__cta p15', {
        'container--xl split': layout === 'split' || layout === undefined,
        'ac container--l full': layout === 'full'
      })}>
        <div className='shadow__box bcw p15'>
          <div className={cx('f x fw aic', {
            'jcb': layout === 'split' || layout === undefined,
            'jcc': layout === 'full'
          })}>
            {imageId && (
              <div className='block__cta-icon pb1'>
                <Image width={400} imageId={imageId} alt={title} />
              </div>
            )}
            <div className='x block__cta-text'>
              {title && (<h2 className='m0 p0 mb05'>{title}</h2>)}
              <BlockContent blocks={description}  />
            </div>
            {ctaCopy && (
              <div className='x block__cta-button mt05 ac'>
                {ctaAction ? this.handleCTA(ctaCopy, ctaAction) : (
                  <PageLink to='/' className='button button__peach inline-block button__outline'>
                    <span>{ctaAction}</span>
                  </PageLink>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default BlockCta
